import { Component, HostBinding } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-Premium-event-image-preview',
    templateUrl: './premium.event.image.preview.component.html'
})

export class PremiumEventImagePreviewComponent {

    imageUrl: string;

    @HostBinding('class.mx-auto')

    auto = true;

    constructor(public activeModal: NgbActiveModal) { }

    setImage(image: string) {
        this.imageUrl = image;
    }

    close() {
        this.activeModal.dismiss();
    }
}
